<div class="custom-control custom-radio">
  <input
    [formControl]="control"
    class="custom-control-input"
    type="radio"
    [id]="id"
    [name]="name"
    [value]="label"
    (change)="changed.emit($event)"
  />
  <label class="form-check-label custom-control-label" [for]="id">{{ label }}</label>
</div>
